import React, { FC } from 'react';
import { StyleProp, Text, TextStyle, View } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { useManageAdditionalLinkInfo } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/hooks/useManageAdditionalLinkInfo';
import { BULLET } from '@v2/pages/common/constants/base.constants';

interface AdditionalLinkInfoProps {
  C: ColorFunction;
}

const AdditionalLinkInfo: FC<AdditionalLinkInfoProps> = ({ C }) => {
  const textStyles: StyleProp<TextStyle> = [font.Body, { color: C('Label/Light/Tertiary') }];

  const { additionalLinkText, filteredDPR, partName, isDPRExist, shouldDisplayPartNameAndDPR } = useManageAdditionalLinkInfo();

  return (
    <View style={[{ gap: scale(TOP_BLOCK_CONFIG.gapBetweenInfoLines) }]}>
      {additionalLinkText && <Text style={textStyles}>{additionalLinkText}</Text>}

      {shouldDisplayPartNameAndDPR && (
        <Text numberOfLines={1} style={{ alignItems: 'center' }}>
          {partName && (
            <Text style={textStyles}>
              {i18n.t('Part')} {partName}{' '}
            </Text>
          )}
          {partName && isDPRExist && <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{BULLET}</Text>}
          {isDPRExist && (
            <>
              <Text style={textStyles}> {i18n.t('Drawing')}</Text>
              {filteredDPR.map((value, index) => (
                <Text key={index} style={textStyles}>
                  {' '}
                  {value}
                </Text>
              ))}
            </>
          )}
        </Text>
      )}
    </View>
  );
};

export default ColorWrapper(AdditionalLinkInfo);
